import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Switch } from '@material-ui/core';

export interface Props {
  name: string;
  classes: any;
  checked: boolean;
  value: any;
  onChange: any;
}

const styles = {
  root: {
    width: 51,
    height: 31,
    padding: 0,
  },
  switchBase: {
    padding: 1,
    '& + $track': {
      backgroundColor: '#E9E9EA',
      opacity: 1,
      border: 'none',
    },
    '&$checked': {
      transform: 'translateX(22px)',
      color: 'white',
      '& + $track': {
        backgroundColor: '#52d869',
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#52d869',
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 27,
    height: 27,
  },
  track: {
    borderRadius: 16,
    opacity: 1,
  },
  checked: {},
  focusVisible: {},
};

export const SwitchComponent: React.FC<Props> = props => {
  const { classes } = props;

  return (
    <Switch
      {...props}
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
    />
  );
};

export default withStyles(styles)(SwitchComponent);
